import { Container, Grid } from '@mui/material';

const img = (name: string) => `${process.env.PUBLIC_URL}/images/${name}`;

function XsFooter() {
  return (
    <div className='main_footer'>
      <footer className='first_part'>
        <Container maxWidth='lg' className='footer_container'>
          <Grid container justifyContent='space-around' alignItems='center'>
            <Grid item>
              <img src={img('logo_siea_blue.svg')} alt='SIEA' />
            </Grid>
            <Grid item>
              <img style={{ height: '50px' }} src={img('footerLogo3.svg')} alt='logo' />
            </Grid>
          </Grid>
        </Container>
      </footer>
    </div>
  );
}

export default XsFooter;
